module.exports = __webpack_public_path__ + "images/documentationIcon-7d9b3f76aa5de4e6ac55af419ad39dd2.svg";